import { apiUrl } from "helpers/constants/config.constants";
import { httpDelete, httpGet, httpPatch, httpPost } from "./http.service";

export interface CustomerModel {
  customerId: string
  userId: string
  projectId: string
  name: string
  email: string
  phoneNo: string
  address: string
  country: string
  currency: string
  type: string
}

export const doListCustomer = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.customer.list, { skip, limit: 99999 }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doGetCustomerDetail = (userId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.customer.get(userId)).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doCreateCustomer = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.customer.create, { ...params }).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const doUpdateCustomer = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.customer.update(params.userId as string), { ...params }).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doDeleteCustomer = (userId: string) => {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.customer.delete(userId)).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}